import styled, { css } from 'styled-components';
import { BKJIcon } from '../BKJIcon/index.js';
import { InputErrorMessageCSS } from '../common/index.js';
export const InnerWrapper = styled.div `
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 232px;
  height: 164px;

  padding: 15px;
  background-color: ${({ theme, error }) => error ? theme.colors.ErrorBackground : theme.colors.Grey1};
`;
export const FileWrapper = styled.div `
  display: flex;
  flex-direction: ${({ isFileSelected }) => (isFileSelected ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  margin-top: auto;
  gap: 6px;
`;
export const CloseIcon = styled(BKJIcon) `
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
`;
export const DocumentIcon = styled(BKJIcon) `
  min-width: 24px;
`;
export const Input = styled.input `
  display: none;
  justify-content: center;
  align-items: center;
`;
export const BKJFileInputText = styled.label `
  ${({ theme }) => theme.typography.Body};
  ${({ theme }) => theme.common.Ellipsis};
  max-width: 150px;
  color: ${({ theme, isFileSelected }) => isFileSelected ? theme.colors.TextDarkGrey : theme.colors.TextDisabled};
  ${({ error }) => error &&
    css `
      color: ${({ theme }) => theme.colors.ErrorDefault};
    `};
`;
export const BKJFileInputLabel = styled.p `
  cursor: pointer;
  ${({ theme }) => theme.typography.TextLink};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  margin-top: auto;
`;
export const ErrorText = styled.label `
  ${InputErrorMessageCSS}
`;
//# sourceMappingURL=BKJFileInput.styled.js.map